import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div className="max-w-3xl mx-auto py-8 px-4">
    <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
    <p className="mb-4">Effective Date: June 2024</p>
  
    <h2 className="text-xl font-semibold mt-6 mb-2">1. Introduction</h2>
    <p className="mb-4">
      At Deacon (“we,” “us,” or “our”), your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and protect your information when you use our website, mobile application, and messaging services.
    </p>
  
    <h2 className="text-xl font-semibold mt-6 mb-2">2. Information We Collect</h2>
    <ul className="list-disc ml-6 mb-4">
      <li>Personal identification information (such as name, email address, and phone number)</li>
      <li>Demographic details (such as age, gender, and location)</li>
      <li>Account credentials and profile settings</li>
      <li>Device information (browser type, IP address, OS, device identifiers)</li>
      <li>Usage data (including app interactions, features used, and visit timestamps)</li>
      <li>Cookies and similar technologies for analytics and personalization</li>
      <li>SMS consent and opt-in preferences</li>
    </ul>
  
    <h2 className="text-xl font-semibold mt-6 mb-2">3. Message Consent and SMS Communications</h2>
    <p className="mb-4">
      By providing your mobile phone number and opting in, you consent to receive SMS communications from us, which may include service updates, account notifications, and support messages. Message frequency varies by user.
    </p>
    <p className="mb-4">
      <strong>Message and data rates may apply.</strong> You may opt out at any time by replying "STOP" to any message you receive. For help, reply "HELP" or contact us at <strong>help@getdeacon.com</strong>.
    </p>
    <p className="mb-4">
      We do <strong>not</strong> share SMS opt-in data or consent with third parties or affiliates for marketing or promotional purposes.
    </p>
  
    <h2 className="text-xl font-semibold mt-6 mb-2">4. How We Use Your Information</h2>
    <ul className="list-disc ml-6 mb-4">
      <li>To provide and maintain our services</li>
      <li>To process transactions and manage your account</li>
      <li>To send account updates, alerts, and support messages (via email or SMS)</li>
      <li>To personalize and improve your user experience</li>
      <li>To ensure platform safety and prevent fraud</li>
      <li>To comply with legal obligations and respond to law enforcement requests</li>
    </ul>
  
    <h2 className="text-xl font-semibold mt-6 mb-2">5. Information Sharing and Disclosure</h2>
<ul className="list-disc ml-6 mb-4">
  <li>
    We do <strong>not</strong> share mobile information (including phone numbers) with third parties or affiliates for marketing or promotional purposes.
  </li>
  <li>
    Information may be shared with trusted subcontractors who perform services on our behalf, such as customer support or technical infrastructure. These parties are bound by confidentiality agreements and may only use information as necessary to support our services.
  </li>
  <li>
    Text messaging originator opt-in data and consent will <strong>not</strong> be shared with any third parties.
  </li>
  <li>
    We may disclose information if required by law, regulation, subpoena, or to protect our legal rights and those of our users.
  </li>
</ul>

  
    <h2 className="text-xl font-semibold mt-6 mb-2">6. Cookies and Tracking Technologies</h2>
    <p className="mb-4">
      We use cookies and similar technologies to enhance user experience and gather analytics. You may control cookie preferences through your browser settings.
    </p>
  
    <h2 className="text-xl font-semibold mt-6 mb-2">7. Mobile App Permissions</h2>
    <p className="mb-4">
      We may request access to device permissions such as camera, location, or storage to provide relevant app functionality. These are optional and can be managed through your device settings.
    </p>
  
    <h2 className="text-xl font-semibold mt-6 mb-2">8. Data Retention</h2>
    <p className="mb-4">
      We retain your data only as long as necessary for legitimate business purposes or legal compliance. Data is securely deleted when no longer required.
    </p>
  
    <h2 className="text-xl font-semibold mt-6 mb-2">9. Data Security</h2>
    <p className="mb-4">
      We use technical, administrative, and physical security measures to protect your data. However, no system is fully secure, and we encourage you to protect your login credentials.
    </p>
  
    <h2 className="text-xl font-semibold mt-6 mb-2">10. Children’s Privacy</h2>
    <p className="mb-4">
      Our services are not intended for children under 13. We do not knowingly collect personal information from children. If we learn such data has been submitted, we will promptly delete it.
    </p>
  
    <h2 className="text-xl font-semibold mt-6 mb-2">11. Your Privacy Rights</h2>
    <p className="mb-4">
      You may request to access, update, correct, or delete your personal data at any time. Contact us at <strong>help@getdeacon.com</strong> to exercise your rights. We may require verification before processing requests.
    </p>
  
    <h2 className="text-xl font-semibold mt-6 mb-2">12. CCPA and GDPR Compliance</h2>
    <p className="mb-4">
      If you are a California resident or located in the EU/EEA, you have additional rights including the right to request disclosure, deletion, or restriction of your personal information. We honor all applicable legal requests in accordance with CCPA and GDPR.
    </p>
  
    <h2 className="text-xl font-semibold mt-6 mb-2">13. Changes to This Privacy Policy</h2>
    <p className="mb-4">
      We may update this Privacy Policy periodically. When we do, we will revise the “Effective Date” and post the updated version. Continued use of our services after changes means you accept the revised policy.
    </p>
  
    <h2 className="text-xl font-semibold mt-6 mb-2">14. Contact Us</h2>
    <p>
      For any questions or concerns about this Privacy Policy or your data, please contact us:
      <br />
      <strong>Email:</strong> help@getdeacon.com
    </p>
  </div>
  

  );
} 